import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToggleState {
    isOpen: boolean;
}

const initialState: ToggleState = {
    isOpen: false,
};

const OpenModalSlice = createSlice({
    name: 'openModal',
    initialState,
    reducers: {
        setIsOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setIsOpen } = OpenModalSlice.actions;
export default OpenModalSlice;import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToggleState {
    isOpen: boolean;
}

const initialState: ToggleState = {
    isOpen: false,
};

const OpenModalSlice = createSlice({
    name: 'openModal',
    initialState,
    reducers: {
        setIsOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setIsOpen } = OpenModalSlice.actions;
export default OpenModalSlice;